export class Login {
    email: string = ''
    senha: string = ''
    confirmacao: string = ''
    clienteId?: number = 0
}